import AcademicCap from './academic-cap.svg?react';
import Aggregate from './aggregate.svg?react';
import ArrowDownOnSquare from './arrowDownOnSquare.svg?react';
import ArrowLeft from './arrowLeft.svg?react';
import ArrowLeftEndOnRectangle from './arrowLeftEndOnRectangle.svg?react';
import ArrowLeftStartOnRectangle from './arrowLeftStartOnRectangle.svg?react';
import ArrowRight from './arrowRight.svg?react';
import ArrowSmallDownMini from './arrowSmallDownMini.svg?react';
import ArrowSmallLeft from './arrowSmallLeft.svg?react';
import ArrowSmallRight from './arrowSmallRight.svg?react';
import ArrowSmallUpMini from './arrowSmallUpMini.svg?react';
import ArrowTopBottom from './arrow-top-bottom.svg?react';
import ArrowTopRightOnSquare from './arrowTopRightOnSquare.svg?react';
import ArrowUpOnSquare from './arrowUpOnSquare.svg?react';
import Bag from './bag.svg?react';
import Bold from './Bold.svg?react';
import BroomSparkleClean from './broom-sparkle-clean-brush.svg?react';
import BrowserBlocked from './browserBlocked.svg?react';
import BrowserBroken from './browserBroken.svg?react';
import BubbleAlert from './bubble-alert.svg?react';
import BubbleMessage from './bubble-message.svg?react';
import BuildingOffice from './buildingOffice.svg?react';
import Buildings from './buildings.svg?react';
import BulletList from './bulletList.svg?react';
import Calendar from './calendar.svg?react';
import CalendarCheck from './calendarCheck.svg?react';
import CalendarEdit from './calendar-edit.svg?react';
import CalendarEditFill from './calendar-edit-solid.svg?react';
import ChainLink from './chainLink.svg?react';
import Check from './check.svg?react';
import CheckCircle from './checkCircle.svg?react';
import CheckCircleFillMini from './checkCircleFillMini.svg?react';
import CheckSmall from './checkSmall.svg?react';
import CheveronDown from './cheveronDown.svg?react';
import CheveronLeft from './cheveronLeft.svg?react';
import CheveronRight from './cheveronRight.svg?react';
import CheveronUp from './cheveronUp.svg?react';
import CheveronUpDown from './cheveronUpDown.svg?react';
import ChevronDownSmall from './chevronDownSmall.svg?react';
import ChevronLeftSmall from './chevronLeftSmall.svg?react';
import ChevronRightSmall from './chevronRightSmall.svg?react';
import ChevronUpSmall from './chevronUpSmall.svg?react';
import Circle from './circle.svg?react';
import CircleBan from './circle-ban.svg?react';
import CircleLarge from './circleLarge.svg?react';
import CircleLargeDotted from './circleLargeDotted.svg?react';
import CircleSmall from './circleSmall.svg?react';
import CircleSmallFilled from './circleSmallFilled.svg?react';
import CircleStack from './circleStack.svg?react';
import Clock from './clock.svg?react';
import ClockCircleFillMini from './clockCircleFillMini.svg?react';
import CodeLines from './codelines.svg?react';
import Collection from './collection.svg?react';
import Copy from './copy.svg?react';
import Court from './court.svg?react';
import Cross from './cross.svg?react';
import CrossCircle from './crossCircle.svg?react';
import CrossCircleFillMini from './crossCircleFillMini.svg?react';
import CrossCircleMini from './crossCircleMini.svg?react';
import CrossSmall from './crossSmall.svg?react';
import CubeTransparent from './cubeTransparent.svg?react';
import DocumentDuplicate from './documentDuplicate.svg?react';
import DocumentText from './documentText.svg?react';
import DotCircleFillMini from './dotCircleFillMini.svg?react';
import Dots from './dots.svg?react';
import Eight from './Eight.svg?react';
import EllipsisVertical from './ellipsisVertical.svg?react';
import Envelope from './envelope.svg?react';
import ExclamationCircle from './exclamationCircle.svg?react';
import ExclamationCircleFillMini from './exclamationCircleFillMini.svg?react';
import ExclamationTriangleFill from './exclamationTriangleFill.svg?react';
import ExclamationTriangleMini from './exclamationTriangleMini.svg?react';
import Expand from './expand.svg?react';
import Eye from './eye.svg?react';
import EyeFill from './eyeFill.svg?react';
import FaceFrown from './faceFrown.svg?react';
import Filter from './filter.svg?react';
import Five from './Five.svg?react';
import Four from './Four.svg?react';
import Globe from './globe.svg?react';
import GlobeFill from './globeFill.svg?react';
import Hamburger from './hamburger.svg?react';
import Heart from './heart.svg?react';
import InformationCircle from './informationCircle.svg?react';
import InformationCircleFillMini from './informationCircleFillMini.svg?react';
import InformationCircleMini from './informationCircleMini.svg?react';
import Italic from './Italic.svg?react';
import Language from './language.svg?react';
import Link from './link.svg?react';
import LinkSlash from './linkSlash.svg?react';
import ListMagnify from './listMagnify.svg?react';
import Lock from './lock.svg?react';
import LockClosedFill from './lockClosedFill.svg?react';
import LockOpenFill from './lockOpenFill.svg?react';
import Magnify from './magnify.svg?react';
import MiniCheck from './miniCheck.svg?react';
import Minimize from './minimize.svg?react';
import Minus from './minus.svg?react';
import MinusCircleFillMini from './minusCircleFillMini.svg?react';
import Nine from './Nine.svg?react';
import NumberedList from './numberedList.svg?react';
import One from './One.svg?react';
import Pencil from './pencil.svg?react';
import PencilSquare from './pencilSquare.svg?react';
import Plus from './plus.svg?react';
import QuestionMarkCircleFillMini from './questionMarkCircleFillMini.svg?react';
import RightAngle from './rightAngle.svg?react';
import Seven from './Seven.svg?react';
import SignalActive from './signalActive.svg?react';
import Six from './Six.svg?react';
import Sketch from './sketch.svg?react';
import Sparkles from './sparkles.svg?react';
import SplitPath from './splitPath.svg?react';
import SquareInfo from './square-info.svg?react';
import SquareInfoSolid from './square-info-solid.svg?react';
import Star from './star.svg?react';
import StepBack from './stepBack.svg?react';
import StepForwards from './stepForwards.svg?react';
import Swap from './swap.svg?react';
import SwapSlash from './swapSlash.svg?react';
import Swatch from './swatch.svg?react';
import Table from './Table.svg?react';
import Three from './Three.svg?react';
import Trash from './trash.svg?react';
import TrashStrikethrough from './trashStrikethrough.svg?react';
import Two from './Two.svg?react';
import User from './user.svg?react';
import UserCheckFill from './userCheckFill.svg?react';
import UserCircle from './userCircle.svg?react';
import UserMinusFill from './userMinusFill.svg?react';
import UserPlus from './user-plus.svg?react';
import UserPlusFill from './user-plus-solid.svg?react';
import Wreath from './wreath.svg?react';
import Zero from './Zero.svg?react';

export const Icons = {
  AcademicCap,
  Aggregate,
  ArrowDownOnSquare,
  ArrowLeft,
  ArrowLeftEndOnRectangle,
  ArrowLeftStartOnRectangle,
  ArrowRight,
  ArrowSmallDownMini,
  ArrowSmallLeft,
  ArrowSmallRight,
  ArrowSmallUpMini,
  ArrowTopBottom,
  ArrowTopRightOnSquare,
  ArrowUpOnSquare,
  Bag,
  Bold,
  BroomSparkleClean,
  BrowserBlocked,
  BrowserBroken,
  BubbleAlert,
  BubbleMessage,
  BuildingOffice,
  Buildings,
  BulletList,
  Calendar,
  CalendarCheck,
  CalendarEdit,
  CalendarEditFill,
  ChainLink,
  Check,
  CheckCircle,
  CheckCircleFillMini,
  CheckSmall,
  CheveronDown,
  CheveronLeft,
  CheveronRight,
  CheveronUp,
  CheveronUpDown,
  ChevronDownSmall,
  ChevronLeftSmall,
  ChevronRightSmall,
  ChevronUpSmall,
  Circle,
  CircleBan,
  CircleLarge,
  CircleLargeDotted,
  CircleSmall,
  CircleSmallFilled,
  CircleStack,
  Clock,
  ClockCircleFillMini,
  CodeLines,
  Collection,
  Copy,
  Court,
  Cross,
  CrossCircle,
  CrossCircleFillMini,
  CrossCircleMini,
  CrossSmall,
  CubeTransparent,
  DocumentDuplicate,
  DocumentText,
  DotCircleFillMini,
  Dots,
  Eight,
  EllipsisVertical,
  Envelope,
  ExclamationCircle,
  ExclamationCircleFillMini,
  ExclamationTriangleFill,
  ExclamationTriangleMini,
  Expand,
  Eye,
  EyeFill,
  FaceFrown,
  Filter,
  Five,
  Four,
  Globe,
  GlobeFill,
  Hamburger,
  Heart,
  InformationCircle,
  InformationCircleFillMini,
  InformationCircleMini,
  Italic,
  Language,
  Link,
  LinkSlash,
  ListMagnify,
  Lock,
  LockClosedFill,
  LockOpenFill,
  Magnify,
  MiniCheck,
  Minimize,
  Minus,
  MinusCircleFillMini,
  Nine,
  NumberedList,
  One,
  Pencil,
  PencilSquare,
  Plus,
  QuestionMarkCircleFillMini,
  RightAngle,
  Seven,
  SignalActive,
  Six,
  Sketch,
  Sparkles,
  SplitPath,
  SquareInfo,
  SquareInfoSolid,
  Star,
  StepBack,
  StepForwards,
  Swap,
  SwapSlash,
  Swatch,
  Table,
  Three,
  Trash,
  TrashStrikethrough,
  Two,
  User,
  UserCheckFill,
  UserCircle,
  UserMinusFill,
  UserPlus,
  UserPlusFill,
  Wreath,
  Zero,
};
